// extracted by mini-css-extract-plugin
export var layoutContainer = "_b4-0";
export var layoutContainerNoRounding = "_b4-6";
export var layoutContainerOpen = "_b4-5";
export var layoutContainerResizing = "_b4-1";
export var mainContent = "_b4-2";
export var resizeDivider = "_b4-3";
export var slidePanel = "_b4-4";